{
  "adobeExperienceCloudNoOrgsSelect": "Seleccionar otra cuenta de organización",
  "adobeExperienceCloudSelectedOrg": "Organización seleccionada: {org}",
  "appSwitcherLinkOutIconLabel": "Abrir en una nueva ventana",
  "feedback button default": "Comentarios",
  "help": "Ayuda",
  "launchsidebar": "Iniciar barra lateral",
  "more actions": "Más acciones",
  "searchButton": "Buscar",
  "solutionSwitcher": "Cambiar a otra solución",
  "solutionSwitcherList": "Lista de aplicaciones",
  "solutionSwitcherPopover": "Apertura emergente de la lista de aplicaciones"
}
